// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2UYdE","container":"styles_container__2Yw1S","title":"styles_title__2g3Vy","wrapper":"styles_wrapper__2Mtnq","answer":"styles_answer__1XPBy"};